import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
const EditTier = ({ deviation, editTier })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItem, {
        label: t('common.edit'),
        onClick: editTier,
        biData: {
            evid: BiEventType.TIER_EDIT_CLICK,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId
        }
    });
};
EditTier.displayName = 'EditTier';
export default EditTier;
